import { useState } from "react";
import {SupportWidget} from "../SupportWidget/SupportWidget"
const ChatIframe = ({ src, width = 350, height = 500 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const toggleChat = () =>{
    setActiveTab("")
    setIsOpen((prev) => !prev)};


    const isLoggedIn= !!sessionStorage.getItem('userToken')
if(!isLoggedIn){
  return null
}
  return (
    <div className="absolute bottom-4 right-6 z-50 flex flex-col items-end space-y-3">
      {/* Chat Iframe Panel */}
      {isOpen ? (
        <div
          className={`bg-white rounded-xl shadow-2xl overflow-hidden transition-all duration-300 ${
            isOpen
              ? "opacity-100 translate-y-0 pointer-events-auto"
              : "opacity-0 translate-y-4 pointer-events-none"
          }`}
          style={{ width: `${width}px`, height: `${height}px` }}
        >
          {/* <button
            onClick={toggleChat}
            className=" h-14 flex items-center p-4  float-right bg-gradient-to-br from-indigo-500 to-purple-500 text-white text-2xl rounded-full shadow-lg hover:scale-105 transition-transform duration-200"
            aria-label="Toggle Chat"
          >
            {isOpen ? "✖" : "💬"}
          </button> */}
          {activeTab==="bot"?<iframe
            src={src}
            title="Live Chat"
            className="w-full h-full border-0"
          />:
          <SupportWidget 
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          />
        }</div>
      ) : null}
      {/* Toggle Button */}
      <button
        onClick={toggleChat}
        className="w-14 h-14 flex items-center justify-center bg-gradient-to-br 
        bg-green-500
        text-white text-2xl rounded-full shadow-lg hover:scale-105 transition-transform duration-200"
        aria-label="Toggle Chat"
      >
        {isOpen ? "✖" : "💬"}
      </button>
    </div>
  );
};

export default ChatIframe;
